<ng-template appFeatureDiscovery [featureFlagKey]="featureFlagKey" [customTarget]="customTarget">
    <span class="container"> new </span>
</ng-template>
